<template>
  <template v-for="(node, index) in contentData" :key="getNodeKey(node, index)">
    <template v-if="isTextNode(node)">
      {{ node.text }}
    </template>

    <component
      :is="getResolvedTag(node)"
      v-else
      :class="getTagClassList(node)"
      v-bind="getNodeAttrs(node)"
    >
      <template v-if="node.text">
        {{ node.text }}
      </template>

      <MpfContentRenderer
        v-if="node.children?.length"
        :transform-to="transformTo"
        :content-data="node.children"
      />
    </component>
  </template>
</template>

<script setup lang="ts">
  import { RouterLink } from 'vue-router';
  import {
    mpfContentRendererProps,
    type MpfContentElementNode,
    type MpfContentNode,
    type MpfContentTextNode,
    defaultTagClasses,
  } from './MpfContentRenderer.props';

  const props = defineProps(mpfContentRendererProps);

  function isTextNode(node: MpfContentNode): node is MpfContentTextNode {
    return !('tag' in node);
  }

  function getNodeKey(node: MpfContentNode, index: number): string {
    if (isTextNode(node)) {
      return `text-${index}-${node.text}`;
    }

    return `${node.tag}-${index}-${node.text ?? 'node'}`;
  }

  function getResolvedTag(node: MpfContentNode): string | typeof RouterLink {
    if (isTextNode(node)) {
      return 'span';
    }

    if (node.tag === 'router-link') {
      return RouterLink;
    }

    return node.tag;
  }

  function getTagClassList(node: MpfContentElementNode): string[] {
    const baseClasses = defaultTagClasses.value[node.tag] ?? [];
    const customClasses = node.tagClasses ?? [];

    return [...baseClasses, ...customClasses];
  }

  function getNodeAttrs(
    node: MpfContentElementNode,
  ): Record<string, string | number | boolean | null | undefined> {
    const attrs = { ...(node.attrs ?? {}) };

    if (node.tag === 'router-link') {
      // normalize href → to
      if ('href' in attrs && !('to' in attrs)) {
        attrs.to = attrs.href;
        delete attrs.href;
      }

      // patch tenant path (only for string paths)
      if (typeof attrs.to === 'string') {
        attrs.to = props.transformTo(attrs.to);
      }
    }

    return attrs;
  }
</script>
